// extracted by mini-css-extract-plugin
module.exports = {"articleCard":"ArticleCard_articleCard__12RIH","cardImg":"ArticleCard_cardImg__ZR4Op","content":"ArticleCard_content__4QUOB","title":"ArticleCard_title__UnzZU"};